import React from 'react'
import { Modal } from 'antd'
const CustomModal = ({ showModal, setShowModal, children, title }) => {
    return (
        <>
            <Modal
                title={title}
                open={showModal}
                setShowModal={setShowModal}
                onCancel={() => setShowModal(false)}
                footer={false}
                centered
            >
                {children}
            </Modal>
        </>
    )
}
export default CustomModal
